/**
 * Blueprint for the action buttons.
 */
export class ActionButton {
  type: string;
  icon: string;
  tooltip: string;
  disabled?: boolean | {};
  hideKey?: string;

  constructor(public actionButton: { type: string; icon: string; tooltip: string; disabled?: boolean | {}; hideKey?: string }) {
    this.type = actionButton.type;
    this.icon = actionButton.icon;
    this.tooltip = actionButton.tooltip;
    this.disabled = actionButton.disabled;
    this.hideKey = actionButton.hideKey;
  }
}
